import { render, staticRenderFns } from "./RuleSearchMenu.vue?vue&type=template&id=4ec8dcfa&"
import script from "./RuleSearchMenu.vue?vue&type=script&lang=ts&"
export * from "./RuleSearchMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RuleSearchMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports